let forms = document.querySelectorAll('form[data-live-search-form]');

forms.forEach(function(form) {
  form.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault(); 
      
      // Select all links with the class .search-flydown--product
      var links = document.querySelectorAll('a.search-flydown--product');
      
      // Retrieve the search query from the specified input field
      const inputSelector = '.live-search-form-field';
      const searchQuery = form.querySelector(inputSelector).value.trim();
      const queryString = encodeURIComponent(searchQuery);
      
      // Filter links that do not include '#' in their href and check if aria-label includes the searchQuery
      const validLinks = Array.from(links).filter(link => 
        !link.href.includes('#') && 
        link.getAttribute('aria-label').toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      // Redirect if there's at least one valid link and the search query is at least 5 characters long
      if (validLinks.length >= 1 && searchQuery.length >= 5) {
        window.location.href = validLinks[0].href;
      } else {
        console.log(validLinks.length + ' valid .search-flydown--product links found that match the search query. Redirecting only under specific conditions.');
        
        // Redirect to the form's action with the query string
        window.location.href = `${form.action}?q=${queryString}`;
      }
    }
  });
});
